const WhereDoYouPreferToBeBased = Object.freeze({
  RIGHT_IN_THE_CENTRE: 'right_in_the_centre',
  A_QUIETER_NEIGHBOURHOOD: 'a_quiter_neighbourhood',
  SECLUDED_AND_PRIVATE: 'secluded_and_private',
  NO_PREFERENCE: 'no_preference',
} as const);

export type WhereDoYouPreferToBeBased =
  (typeof WhereDoYouPreferToBeBased)[keyof typeof WhereDoYouPreferToBeBased];
export const allWhereDoYouPreferToBeBased: [WhereDoYouPreferToBeBased, ...WhereDoYouPreferToBeBased[]] = Object.values(WhereDoYouPreferToBeBased) as [WhereDoYouPreferToBeBased, ...WhereDoYouPreferToBeBased[]];

export default WhereDoYouPreferToBeBased;

